export default __webpack_public_path__ + "static/media/NEAS0650.34I-39295_-23327_0.151badeb.jpg";